module.exports = __webpack_public_path__ + "img/zfcg_11.fe349293.png";